const config = {
  url: process.env.REACT_APP_HAPI_URL || 'http://localhost:8000/api/'
}

export default config
